import $ from 'jquery';
import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';
import { getCurrentHierarchyParameters } from 'cadenza/api-client/processing-param-util';

import {
  MIMETYPE_DISY_POST_MESSAGE,
  PARAMETER_CONDITION_HASH,
  EXECUTION_CONFIRMED
} from './api-constants';
import { MIMETYPE_JSON, MIMETYPE_TEXT } from 'cadenza/model/media-type';
import { ajax } from './api';

/**
 * @param {ResultTableAjaxRequestParams} options
 * @return {Promise<TableDataDto>}
 */
export function getTableData (options) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set('offset', options.offset || 0);
  urlParams.set('limit', options.limit);
  urlParams.set('orderByColumn', $.type(options.orderByColumn) === 'number' ? options.orderByColumn : -1);
  urlParams.set('orderAsc', typeof options.orderAsc === 'boolean' ? options.orderAsc : true);
  return ajax(`/processingChain?${urlParams.toString()}`, {
    headers: {
      Accept: MIMETYPE_JSON
    },
    traditional: true,
    signal: options.signal
  });
}

export function getTableConfiguration (options) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set('orderByColumn', $.type(options.orderByColumn) === 'number' ? options.orderByColumn : -1);
  urlParams.set('orderAsc', typeof options.asc === 'boolean' ? options.asc : true);
  return ajax(`/processingChain/table/configuration?${urlParams.toString()}`, {
    headers: {
      Accept: MIMETYPE_JSON
    },
    traditional: true,
    signal: options.signal
  });
}

export function getProcessingUrl (process) {
  if (process.chainingCondition) {
    return getChainingUrl(process);
  }

  if (process.type === 'custom' && process.communicationType === 'URL' && process.resultHandlingConfig.resultHandlingTypeShortName === 'popup') {
    return _getProcessingUrl(cadenzaUrl('/pages/processingChain/customWebApplication/postToWebApplicationPage.xhtml'), process);
  }

  return _getProcessingUrl(cadenzaUrl('/processingChain'), process);
}

export function checkResultLimits (process) {
  return ajax(_getProcessingUrl('/processingChain/checkResultLimits', process));
}

export function storeRequestParameterValue (parameter) {
  return ajax('/processingChain/parameters', {
    type: 'put',
    data: JSON.stringify(parameter),
    contentType: MIMETYPE_TEXT
  });
}

function _getProcessingUrl (baseUrl, process) {
  const sourceUrlParams = new URLSearchParams(window.location.search);
  const targetUrlParams = new URLSearchParams();
  if (sourceUrlParams.has(PARAMETER_CONDITION_HASH)) {
    targetUrlParams.set(PARAMETER_CONDITION_HASH, sourceUrlParams.get(PARAMETER_CONDITION_HASH));
  }
  if (process.conditionValueSetHash) {
    targetUrlParams.set(PARAMETER_CONDITION_HASH, process.conditionValueSetHash);
  }
  if (sourceUrlParams.has(EXECUTION_CONFIRMED)) {
    targetUrlParams.set(EXECUTION_CONFIRMED, sourceUrlParams.get(EXECUTION_CONFIRMED));
  }
  targetUrlParams.set('selector', sourceUrlParams.get('selector') || process.processingPath[0]);
  const hierarchyParams = getCurrentHierarchyParameters();
  for (const paramName in hierarchyParams) {
    targetUrlParams.set(paramName, hierarchyParams[paramName]);
  }
  for (const processing of process.processingPath.slice(1)) {
    targetUrlParams.append('processings', processing);
  }
  if (process.sourceProcessingRow != null) {
    targetUrlParams.set('sourceProcessingRow', process.sourceProcessingRow);
    sourceUrlParams.getAll('processings').forEach(p => targetUrlParams.append('sourceProcessings', p));
  }
  if (process.sourceOrderByColumn != null) {
    targetUrlParams.set('sourceOrderByColumn', process.sourceOrderByColumn);
    targetUrlParams.set('sourceOrderAsc', process.sourceOrderAsc);
  }
  if (process.orderByColumn != null) {
    targetUrlParams.set('orderByColumn', process.orderByColumn);
    targetUrlParams.set('orderAsc', process.orderAsc);
  }
  return baseUrl + '?' + targetUrlParams;
}

function getChainingUrl (process) {
  const sourceUrlParams = new URLSearchParams(window.location.search);
  const targetUrlParams = new URLSearchParams({
    selector: sourceUrlParams.get('selector'),
    chainingSelector: process.chainingSelector,
    chainingCondition: process.chainingCondition
  });
  if (sourceUrlParams.has(PARAMETER_CONDITION_HASH)) {
    targetUrlParams.set(PARAMETER_CONDITION_HASH, sourceUrlParams.get(PARAMETER_CONDITION_HASH));
  }
  return cadenzaUrl('/chainingProcessing') + '?' + targetUrlParams;
}

export function getTableResultAsObjectSelectionPostMessageEvent (process) {
  const urlParams = new URLSearchParams(process.url.split('?')[1]);
  urlParams.set('integrationId', process.integrationId);
  urlParams.set('urlAlias', process.urlAlias);
  return ajax(`/processingChain?${urlParams.toString()}`, {
    accepts: {
      disyPostMessage: MIMETYPE_DISY_POST_MESSAGE
    },
    converters: {
      'text disyPostMessage': result => result
    },
    dataType: 'disyPostMessage',
    headers: {
      Accept: MIMETYPE_DISY_POST_MESSAGE
    },
    traditional: true
  });
}
